export default __webpack_public_path__ + "static/media/icoSearch-1.8cf1fa32.svg";